<template>
  <div style="height: 100%;">
    <div style="width: 960px">
      <el-row type="flex" justify="end">
        <el-button type="info" icon="el-icon-plus" style="margin-bottom: 10px;" size="small" @click="add()">新增</el-button>
      </el-row>
      <el-table ref="evaluteSet" :data="commonQAs" empty-text="暂无数据" style="width: 100%;" max-height="510">
        <el-table-column :show-overflow-tooltip="true" align="center" prop="question" label="问题" width="100"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" align="center" prop="answer" label="答案"></el-table-column>
        <el-table-column align="center" fixed="right" label="操作" width="150">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="light" content="修改" placement="bottom">
              <el-button type="text" size="mini" @click="edit(scope.row, scope.$index)">
                <svg class="icon icon-bianji" aria-hidden="true">
                  <use xlink:href="#icontable-bianji" />
                </svg>
              </el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="light" content="删除" placement="bottom">
              <el-button type="text" size="mini" @click="deleteByIds(scope.row, scope.$index)">
                <svg class="icon icon-delete" aria-hidden="true">
                  <use xlink:href="#icontable-delete" />
                </svg>
              </el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <div class="table-page text-right">
        <el-pagination style="margin:20px 0 0;width:100% !important;" v-if="this.channelId" background layout="total, prev, pager, next, jumper" :page-size="pageSize" :current-page="pageNum" :total="total" @current-change="handleCurrentChange"></el-pagination>
      </div>
      <el-dialog :title="dialogTitle" width="520px" :destroy-on-close="true" :visible.sync="addmsg" append-to-body :close-on-click-modal="false">
        <el-row>
          <div>
            <el-form :inline="true" label-width="80px">
              <el-form-item label="问题:">
                <el-input v-model="uform.question" maxlength="20" placeholder="最大长度20个字" style="width:380px;"></el-input>
              </el-form-item>
              <el-form-item label="答案:">
                <el-input type="textarea" v-model="uform.answer" maxlength="1000" :rows="5" placeholder="最大长度1000个字" style="width:380px;"></el-input>
              </el-form-item>
            </el-form>
          </div>
          <el-row type="flex" justify="center">
            <el-button size="medium" @click="cancel()">取消</el-button>
            <el-button size="medium" type="primary" @click="submit()">确认</el-button>
          </el-row>
        </el-row>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { listByPage, update, insert, deleteByIds } from '@/api/channel/commonQA.js'
export default {
  components: {},
  data() {
    return {
      // 分页参数
      pageNum: 1,
      pageSize: 10,
      total: 0,
      // 新增/编辑 评价等级信息
      dialogTitle: '',
      addmsg: false,
      uform: {
        question: '',
        answer: '',
        channelId: ''
      },
      commonQAs: [],
      editIndex: ''
    }
  },
  props: {
    channelId: {
      type: String,
      required: true
    },
    tempCommonQAList: {
      type: Array,
      required: true,
      default: () => {
        return []
      }
    }
  },
  mounted() {
    if (!this.channelId) {
      this.commonQAs = this.tempCommonQAList
      this.total = this.tempCommonQAList.length
      this.pageSize = this.tempCommonQAList.length
      this.$emit('setCommonQANum', this.tempCommonQAList.length)
    } else {
      this.getData(this.pageNum)
    }
  },
  watch: {
  },
  computed: {
  },
  methods: {
    getData(_pageNum) {
      if (!this.channelId) {
        console.log('channelId为空')
        return false
      }
      const params = {
        channelId: this.channelId,
        pageNum: _pageNum,
        pageSize: this.pageSize
      }
      listByPage(params).then(res => {
        if (res.code === 2000) {
          this.commonQAs = res.data.data
          this.total = res.data.total
          this.$emit('setCommonQANum', this.total)
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    handleCurrentChange(_pageNum) {
      this.getData(_pageNum)
    },
    // 展示新增框
    add() {
      this.addmsg = true
      this.uform.question = ''
      this.uform.answer = ''
      this.uform.channelId = this.channelId
      this.dialogTitle = '新增配置'
    },
    // 展示编辑框
    edit(row, idx) {
      this.addmsg = true
      this.uform = { ...row }
      this.dialogTitle = '编辑配置'
      this.editIndex = idx
    },
    // 新增/编辑快捷回复内容
    submit() {
      if (this.uform.question.trim().length === 0 || this.uform.answer.trim().length === 0) {
        this.$message.warning('渠道名称或渠道类型不能为空')
        return false
      }
      if (this.dialogTitle === '新增配置') {
        if (this.commonQAs.map(set => { return set.question }).indexOf(this.uform.question) > -1) {
          this.$message.warning('渠道名称已存在，不必新增！')
          return false
        }
        if (!this.uform.channelId) {
          this.tempCommonQAList.push({ ...this.uform })
          this.addmsg = false
          this.$emit('setCommonQANum', this.tempCommonQAList.length)
          this.cancel()
        } else {
          insert(this.uform).then(res => {
            if (res.code === 2000) {
              this.$message.success('数据新增成功!')
              this.addmsg = false
              this.cancel()
              this.getData(1)
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      } else {
        if (this.uform.channelId) {
          this.editIndex = ''
          update([this.uform]).then(res => {
            if (res.code === 2000) {
              this.$message.success('数据更新成功!')
              this.addmsg = false
              this.cancel()
              this.getData(1)
            } else {
              this.$message.error(res.msg)
            }
          })
        } else {
          this.tempCommonQAList.splice(this.editIndex, 1, { ...this.uform })
          this.addmsg = false
          this.editIndex = ''
          this.cancel()
        }
      }
    },
    cancel() {
      this.addmsg = false
      this.uform.message = ''
      this.uform.grade = ''
      this.uform.gradeName = ''
      this.uform.id = ''
      this.uform.createTime = ''
      this.uform.channelId = ''
    },
    // 单条删除
    deleteByIds(row, idx) {
      this.$confirm('是否删除此热点问题?', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        showClose: false,
        type: 'warning'
      }).then(() => {
        if (!row.channelId) {
          this.tempCommonQAList.splice(idx, 1)
          this.$emit('setCommonQANum', this.tempCommonQAList.length)
        } else {
          deleteByIds([row.id]).then(res => {
            if (res.code === 2000) {
              this.$message.success('数据删除成功!')
              this.getData(1)
            } else {
              this.$message.error(res.msg)
            }
          }).catch(err => {
            this.$message.error(err)
          })
        }
      })
    }
  }
}
</script>
<style scoped lang="scss">
.content {
  margin: 0;
  padding: 0;
}
.el-input {
  width: 100%;
}
.search-form.el-form {
  display: flex;
  justify-content: flex-start;
  ::v-deep .el-form-item--small.el-form-item {
    margin-bottom: 10px;
  }
}
.selectInput {
  line-height: inherit;
}
.el-form-item {
  position: relative;
  ::v-deep .el-form-item__label {
    height: 40px;
    line-height: 40px !important;
  }
  .input-border {
    ::v-deep .el-input__inner {
      padding-left: 5px;
      padding-top: 5px;
      padding-bottom: 5px;
      border-radius: 5px;
      border-bottom: 1px solid #dcdfe6;
      height: 35px;
      line-height: 35px;
      font-size: 14px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      word-wrap: break-word;
      word-break: break-all;
      &:focus {
        border-bottom: 1px solid #409eff;
      }
    }
  }
  .icon-delete {
    color: #f66f6a;
  }
}

.table-page {
  // margin: 20px 0;
}

.el-dialog .el-dialog__body .el-button + .el-button {
  margin-left: 10px;
}

.el-form-item__content .el-row {
  width: 100% !important;
}
</style>
<style lang="scss">
.el-textarea__inner {
  resize: none !important;
}
.el-pagination.is-background .el-pagination__editor.el-input {
  width: 30px !important;
}
</style>
